import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {shallowEqual, useSelector} from 'react-redux';
import {Image} from '@nl/component';
import {useDeepEffect} from '@nl/ui';

const MVPDBrand = (props) => {
	const {user} = useSelector((state) => ({
		user: state.client.data.user,
	}), shallowEqual);
	const [mvpdProviderLogo, setMvpdProviderLogo] = useState('');
	const [mvpdProviderLink, setMvpdProviderLink] = useState('');
	const [mvpdProviderName, setMvpdProviderName] = useState('');
	const {logoSuffix} = props;
	useDeepEffect(() => {
		if (user && user.tve && user.tve.loggedIn && user.tve.mvpds) {
			setMvpdProviderLogo(`${user.tve.logoBaseUrl}${user.tve.metadata.mvpd}${logoSuffix}`);
			const loggedInMvpd = user.tve.mvpds.find((mvpd) => mvpd.id === user.tve.metadata.mvpd);
			if (loggedInMvpd.links && loggedInMvpd.links.pc) {
				setMvpdProviderLink(loggedInMvpd.links.pc);
			} else {
				setMvpdProviderLink('');
			}
			setMvpdProviderName(user.tve.metadata.mvpdName);
		} else {
			setMvpdProviderLogo('');
			setMvpdProviderLink('');
			setMvpdProviderName('');
		}
	}, [user]);

	return (
			<div className="nav-bar__img">
				{
					mvpdProviderLink
							? (
									<a href={mvpdProviderLink} target="_blank" rel="noopener noreferrer">
										<Image src={mvpdProviderLogo} alt={mvpdProviderName} />
									</a>
							)
							: (<Image src={mvpdProviderLogo} alt={mvpdProviderName} />
							)
				}
			</div>
	);
};

MVPDBrand.propTypes = {
	logoSuffix: PropTypes.string,
};
MVPDBrand.defaultProps = {
	logoSuffix: '_b_104x45.png',
};

export default MVPDBrand;
